import styled from "styled-components";

export const CoverSheetNoDataConatiner = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
